<template>
  <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
    <div class="justify-content-start d-flex">
      <h3><strong class="text-primary">Administradores</strong></h3>
    </div>
    
    <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
      <search-input-component :search="search" @onSearch="handleSearch"></search-input-component>
      <user-actions 
        :download-url="downloadUrl"
        @disable-users="$emit('disable-users')"
        @bulk-upload="$emit('bulk-upload')"
        @add-user="$emit('add-user')"
      />
    </div>
  </div>
</template>

<script>
import UserActions from './UserActions.vue'

export default {
  name: 'UserFilters',
  
  components: {
    UserActions
  },
  
  props: {
    search: { type: String, default: '' },
    downloadUrl: { type: String, required: true },
    clients: { type: Array, default: () => [] },
    empresas: { type: Array, default: () => [] }
  },
  
  emits: ['search', 'disable-users', 'bulk-upload', 'add-user', 'filter-changed'],
  
  methods: {
    handleSearch(searchText) {
      this.$emit('search', searchText)
      this.$emit('filter-changed', { search: searchText })
    }
  }
}
</script>

<style scoped>
.text-primary {
  color: #1A0054 !important;
}
</style>